export enum SummaryListingSortTypeEnum {
    Alphanumeric = 0,
    Custom = 1
}
